var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _class, _class2, _descriptor, _descriptor2, _descriptor3;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { CustomElement, Component, Prop, Event, html, ifDefined } from '@sick-davinci/ce-decorators';
import { style } from './TagModule.style';
import { Tag } from '../tag/Tag';
import { Link } from '../link/Link';
/**
 * A `davinci-tag-module` is used to represent user input in a concise way. They allow users to filter and find content.
 * 
 * @example
 * ```html
 * <davinci-tag-module><davinci-tag>myTag</davinci-tag></davinci-tag-module>
 * ```
 * @slot { davinci-tag[] } list of `davinci-tag`s
 */

export let TagModule = (_dec = Component({
  tag: 'davinci-tag-module',
  style,
  dependencies: [Tag, Link]
}), _dec2 = Prop({
  reflectAsAttribute: false
}), _dec3 = Reflect.metadata("design:type", String), _dec4 = Prop(), _dec5 = Reflect.metadata("design:type", String), _dec6 = Prop(), _dec7 = Reflect.metadata("design:type", String), _dec8 = Event(), _dec9 = Reflect.metadata("design:type", Object), _dec(_class = (_class2 = class TagModule extends CustomElement {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "name", _descriptor, this);

    _initializerDefineProperty(this, "labelClear", _descriptor2, this);

    _initializerDefineProperty(this, "change", _descriptor3, this);

    this._onRemoveAllClick = () => {
      this.innerHTML = '';
      this.change.emit('');
    };
  }

  /**
   * The value of a `davinci-tag-module` which is a comma separated list with all tags.
   * Hence it's not possible to use commas in a tag name.
   */
  get value() {
    return this._getListOfTags().join(',');
  }

  set value(values) {
    this.innerHTML = '';

    if (!values || typeof values !== 'string') {
      values = '';
    }

    if (values) {
      values.split(',').forEach(e => this._addTag(e));
    }
  }
  /**
   * Identifier for supporting forms. Reserved for future usage.
   */


  componentConnected() {
    this.addEventListener('remove', this._tagRemoved);
  }

  componentDisconnected() {
    this.removeEventListener('remove', this._tagRemoved);
  }

  render() {
    return html`
    <div class="tag-slot">
    <slot @slotchange="${() => {
      this.scheduleRender(true);
    }}">
    </slot>
    ${this._showClearAll()}
    </div>
    `;
  }

  _tagRemoved(event) {
    this.removeChild(event.target);
    this.change.emit(this.value);
  }

  _addTag(tag) {
    const tagElem = new Tag();
    tagElem.textContent = tag;
    tagElem.type = 'filter';
    this.appendChild(tagElem);
  }

  _getListOfTags() {
    const slotAssignedNodes = Array.from(this.children);
    return slotAssignedNodes.map(val => val.name || val.textContent || val.innerHTML);
  }

  _showClearAll() {
    return this._getListOfTags().length > 1 ? html`<davinci-link @click=${this._onRemoveAllClick}>${ifDefined(this.labelClear)}</davinci-link>` : html``;
  }

}, (_applyDecoratedDescriptor(_class2.prototype, "value", [_dec2, _dec3], Object.getOwnPropertyDescriptor(_class2.prototype, "value"), _class2.prototype), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "name", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "labelClear", [_dec6, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "change", [_dec8, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2)) || _class);
